import CompaniesIcon from '@clearkit/icons/glyphs/Companies';
import PeopleIcon from '@clearkit/icons/glyphs/People';
import shuffle from 'lodash/shuffle';

import LoadingBar, { useLoadingBarState } from '~/components/LoadingBar';
import useInterval from '~/hooks/useInterval';

const texts = [
  'Reticulating splines',
  'Checking sources',
  'Calculating diffs',
  'Synthesizing wavelets',
  'Normalizing data sources',
  'Fetching avatars',
  'Asking Ben',
  'Managing expectations',
  'Crunching numbers',
  'Playing it by ear',
  'Herding cats',
  'Defragmenting sectors',
  'Analyzing sentiments',
  'Adjusting sprockets',
  'Tracing outlines',
];
const randomText = () => shuffle(texts)[0];

const LoadingSegment = ({ type }) => {
  const [text, setText] = useState(randomText());

  useInterval(() => {
    setText(randomText());
  }, 3000);

  const loadingBarProps = useLoadingBarState();

  return (
    <div className="flex flex-col items-center justify-center flex-grow w-full text-center">
      <div className="flex flex-col items-center text-center w-xxs">
        {type === 'Companies' ? (
          <CompaniesIcon width={40} height={40} className="text-gray-200" />
        ) : (
          <PeopleIcon width={40} height={40} className="text-gray-200" />
        )}
        <LoadingBar className="w-40 mt-6" {...loadingBarProps} />
        <p className="mt-3 mb-1 text-base font-medium text-gray-600">{text}</p>
      </div>
    </div>
  );
};

LoadingSegment.propTypes = {
  type: PropTypes.oneOf(['Companies', 'People']).isRequired,
};

export default LoadingSegment;
